const popup = document.querySelector('[data-loa-welcome]');
if (popup && !popup.dataset.initialized) {
  const { buildWelcomeRequest, subscribeWelcome, updateWelcomeDiscount } = await import(popup.dataset.apiUrl);
  popup.dataset.initialized = 'true';
  const params = new URLSearchParams(location.search);
  const preview = params.get('loa_welcome_preview') === '1';
  const localPreview = preview && ['localhost', '127.0.0.1'].includes(location.hostname);
  const teaser = document.querySelector('[data-loa-welcome-open]');
  const form = popup.querySelector('[data-loa-form]');
  const input = form.elements.phone;
  const submit = popup.querySelector('[data-loa-submit]');
  const error = popup.querySelector('[data-loa-error]');
  const products = [...popup.querySelectorAll('[data-loa-product]')];
  // Measure the visible garment, not its white source canvas. This also handles
  // catalog photos replaced with a different aspect ratio without stale crop data.
  async function frameGarment(product) {
    const image = product.querySelector('img');
    const garment = product.querySelector('.loa-welcome__garment');
    try {
      image.loading = 'eager';
      await image.decode();
      const canvas = document.createElement('canvas');
      const scale = Math.min(1, 192 / Math.max(image.naturalWidth, image.naturalHeight));
      const width = canvas.width = Math.round(image.naturalWidth * scale);
      const height = canvas.height = Math.round(image.naturalHeight * scale);
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.fillStyle = '#fff';
      context.fillRect(0, 0, width, height);
      context.drawImage(image, 0, 0, width, height);
      const pixels = context.getImageData(0, 0, width, height).data;
      let left = width, top = height, right = 0, bottom = 0;
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const i = (y * width + x) * 4;
          if (Math.max(255 - pixels[i], 255 - pixels[i + 1], 255 - pixels[i + 2]) < 20) continue;
          left = Math.min(left, x); right = Math.max(right, x + 1);
          top = Math.min(top, y); bottom = Math.max(bottom, y + 1);
        }
      }
      if (right - left < 8 || bottom - top < 8) return;
      const padX = (right - left) * .04;
      const padY = (bottom - top) * .04;
      const x = Math.max(0, left - padX);
      const y = Math.max(0, top - padY);
      const cropWidth = Math.min(width, right + padX) - x;
      const cropHeight = Math.min(height, bottom + padY) - y;
      garment.style.setProperty('--loa-product-ratio', String(cropWidth / cropHeight));
      garment.style.setProperty('--loa-source-width', String(width / cropWidth));
      garment.style.setProperty('--loa-source-left', String(x / cropWidth));
      garment.style.setProperty('--loa-source-top', String(y / cropHeight));
      product.dataset.framed = 'true';
    } catch {
      // Cross-origin or unavailable pixels keep the full original visible.
      garment.style.setProperty('--loa-product-ratio', String(image.naturalWidth / image.naturalHeight || 1));
    }
  }
  const motion = popup.querySelector('[data-loa-motion]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'loa-welcome-v1';
  let accepted = false;
  let dismissedAt = 0;
  let shownThisSession = false;
  let lastFocused;
  let paused = reducedMotion.matches || (localPreview && params.get('loa_welcome_pause') === '1');
  let mediaTimer;
  let copyTimer;
  let activeIndex = localPreview ? Math.max(0, Math.min(products.length - 1, Number(params.get('loa_welcome_product')) || 0)) : 0;
  products.forEach((product, index) => {
    product.classList.toggle('is-active', index === activeIndex);
    product.setAttribute('aria-hidden', String(index !== activeIndex));
  });
  let submitting = false;
  let previousScrollY = scrollY;
  let hasScrolled = false;
  let scrollFrame;

  try {
    const state = JSON.parse(localStorage.getItem(key) || '{}');
    accepted = state.accepted === true;
    dismissedAt = Number(state.dismissedAt) || 0;
  } catch {}
  try { shownThisSession = sessionStorage.getItem(`${key}-shown`) === 'true'; } catch {}

  function save() {
    if (!preview) {
      try { localStorage.setItem(key, JSON.stringify({ accepted, dismissedAt })); } catch {}
    }
  }
  function showDiscountState(state) {
    popup.querySelector('[data-loa-discount-status]').textContent = ['applied', 'saved'].includes(state)
      ? "WE’VE ADDED YOUR 10% OFF DISCOUNT CODE TO YOUR CART. YOU’RE READY TO SHOP."
      : 'YOUR 10% OFF CODE IS READY. USE IT AT CHECKOUT ON YOUR NEXT ORDER.';
    popup.dataset.discountState = state;
  }
  async function syncDiscount(apply = false) {
    showDiscountState('ready');
    try {
      const result = await updateWelcomeDiscount({ coupon: popup.dataset.code, root: popup.dataset.root, apply });
      showDiscountState(result.state);
      if (apply && result.sections) {
        const targets = [
          ['main-cart', 'Cart', '.thb-cart-form'],
          ['cart-drawer', 'Cart-Drawer', '.cart-drawer'],
          ['cart-bubble', 'cart-drawer-toggle', '.thb-item-count'],
        ];
        targets.forEach(([section, id, selector]) => {
          const html = result.sections[section];
          if (!html) return;
          const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
          const container = document.getElementById(id);
          const target = container?.querySelector(selector) || container;
          if (replacement && target) target.innerHTML = replacement.innerHTML;
        });
      }
    } catch {
      // Keep the usable code visible without claiming an unverified cart update.
      showDiscountState('ready');
    }
  }
  function updateMedia() {
    clearInterval(mediaTimer);
    motion.hidden = products.length < 2;
    motion.setAttribute('aria-pressed', String(paused));
    motion.setAttribute('aria-label', paused ? 'Play product slideshow' : 'Pause product slideshow');
    motion.querySelector('[data-loa-motion-label]').textContent = paused ? '▷' : 'Ⅱ';
    if (paused || !popup.open || popup.dataset.step !== 'intro' || document.hidden || products.length < 2) return;
    mediaTimer = setInterval(async () => {
      const next = (activeIndex + 1) % products.length;
      const image = products[next].querySelector('img');
      try { await image.decode(); } catch { return; }
      if (!popup.open || paused || popup.dataset.step !== 'intro' || document.hidden) return;
      products[activeIndex].classList.remove('is-active');
      products[activeIndex].setAttribute('aria-hidden', 'true');
      activeIndex = next;
      products[activeIndex].classList.add('is-active');
      products[activeIndex].setAttribute('aria-hidden', 'false');
    }, 3200);
  }
  function showStep(step) {
    popup.dataset.step = step;
    popup.querySelectorAll('[data-loa-step]').forEach(section => { section.hidden = section.dataset.loaStep !== step; });
    const index = ['intro', 'phone', 'success'].indexOf(step);
    popup.querySelectorAll('.loa-welcome__progress i').forEach((dot, i) => dot.classList.toggle('is-current', i <= index));
    const heading = popup.querySelector(`[data-loa-step="${step}"] h2`);
    popup.setAttribute('aria-labelledby', heading.id);
    popup.scrollTop = 0;
    if (popup.open) heading.focus({ preventScroll: true });
    updateMedia();
  }
  function openPopup(automatic = false) {
    if (popup.open) return;
    if (document.querySelector('dialog:modal')) return;
    if (automatic && document.querySelector('.side-panel.active, .side-panel.open, .product-popup-modal[open], #shopify-pc__banner')) return;
    lastFocused = document.activeElement;
    const reviewStep = localPreview ? params.get('loa_welcome_step') : '';
    showStep(accepted && !preview ? 'success' : ['phone', 'success'].includes(reviewStep) ? reviewStep : 'intro');
    if (accepted && !preview) syncDiscount();
    else if (reviewStep === 'success') showDiscountState('saved');
    popup.showModal();
    products.forEach(product => { if (product.dataset.framed !== 'true') frameGarment(product); });
    document.body.classList.add('loa-welcome-open');
    if (!preview) {
      shownThisSession = true;
      try { sessionStorage.setItem(`${key}-shown`, 'true'); } catch {}
    }
    popup.querySelector(`#${popup.getAttribute('aria-labelledby')}`).focus({ preventScroll: true });
    updateMedia();
  }
  function closePopup() {
    if (!popup.open) return;
    if (!accepted) { dismissedAt = Date.now(); save(); }
    popup.close();
  }
  popup.addEventListener('close', () => {
    document.body.classList.remove('loa-welcome-open');
    clearInterval(mediaTimer);
    if (lastFocused?.isConnected) lastFocused.focus({ preventScroll: true });
  });
  popup.addEventListener('cancel', event => { event.preventDefault(); closePopup(); });
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closePopup();
  });
  teaser.addEventListener('click', () => openPopup());
  popup.querySelectorAll('[data-loa-close]').forEach(button => button.addEventListener('click', closePopup));
  popup.querySelector('[data-loa-next]').addEventListener('click', () => showStep('phone'));
  popup.querySelector('[data-loa-back]').addEventListener('click', () => showStep('intro'));
  motion.addEventListener('click', () => { paused = !paused; updateMedia(); });
  reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; updateMedia(); });
  document.addEventListener('visibilitychange', updateMedia);

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting) return;
    error.textContent = '';
    input.removeAttribute('aria-invalid');
    let request;
    try { request = buildWelcomeRequest({ companyId: popup.dataset.company, listId: popup.dataset.list, phone: input.value }); }
    catch (failure) {
      error.textContent = failure.message === 'phone' ? 'PLEASE ENTER A VALID US MOBILE NUMBER.' : 'SIGNUP IS UNAVAILABLE RIGHT NOW. PLEASE TRY AGAIN LATER.';
      if (failure.message === 'phone') input.setAttribute('aria-invalid', 'true');
      input.focus({ preventScroll: true });
      return;
    }
    submitting = true;
    submit.disabled = true;
    submit.textContent = 'SIGNING YOU UP…';
    form.setAttribute('aria-busy', 'true');
    try {
      await subscribeWelcome(request);
      accepted = true;
      save();
      input.value = '';
      submit.textContent = 'ADDING YOUR DISCOUNT…';
      await syncDiscount(true);
      showStep('success');
    } catch {
      error.textContent = 'WE COULDN’T COMPLETE YOUR SIGNUP. PLEASE TRY AGAIN.';
    } finally {
      submitting = false;
      submit.disabled = false;
      submit.textContent = 'GET MY 10% OFF';
      form.removeAttribute('aria-busy');
    }
  });
  popup.querySelector('[data-loa-copy]').addEventListener('click', async () => {
    const status = popup.querySelector('[data-loa-copy-status]');
    try {
      await navigator.clipboard.writeText(popup.dataset.code);
      clearTimeout(copyTimer);
      status.textContent = 'COPIED';
      copyTimer = setTimeout(() => { status.textContent = ''; }, 2200);
    } catch { status.textContent = 'YOUR CODE: ' + popup.dataset.code; }
  });

  function maybeAutoOpen() {
    if (preview || accepted || shownThisSession || popup.open || document.hidden || !hasScrolled || scrollY <= 0) return;
    if (dismissedAt && Date.now() - dismissedAt < 14 * 86400000) return;
    if (/\/(cart|checkouts?|account|policies)(\/|$)|\/pages\/contact(?:\/|$)/.test(location.pathname)) return;
    const grid = [...document.querySelectorAll('#main-content [id^="product-grid"], #main-content .products')].find(element => element.getBoundingClientRect().height > 0);
    const rows = [];
    if (grid) {
      for (const item of [...grid.children]) {
        const rect = item.getBoundingClientRect();
        if (!rect.width || !rect.height) continue;
        let row = rows.find(row => Math.abs(row.top - rect.top) < 3);
        if (!row) { row = { top: rect.top, bottom: rect.bottom }; rows.push(row); }
        row.bottom = Math.max(row.bottom, rect.bottom);
      }
    }
    rows.sort((a, b) => a.top - b.top);
    const reached = rows.length ? rows[Math.min(1, rows.length - 1)].bottom <= innerHeight : (scrollY + innerHeight) / document.documentElement.scrollHeight >= .3;
    if (reached) openPopup(true);
  }
  window.addEventListener('scroll', () => {
    if (scrollY > previousScrollY) hasScrolled = true;
    previousScrollY = scrollY;
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(maybeAutoOpen);
  }, { passive: true });
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try {
      const state = JSON.parse(event.newValue || '{}');
      accepted = state.accepted === true;
      dismissedAt = Number(state.dismissedAt) || 0;
    } catch {}
  });
  if (preview) openPopup();
}
